import winston from 'winston';
import { Loggly } from 'winston-loggly-bulk';

import config from '../config/config';
import * as ClientUtil from './ClientUtil';

ClientUtil
  .getDeviceInfo()
  .then(result => {
    localStorage.setItem("deviceinfo", result);
  });

const getDeviceInfo = () => {
  return localStorage.getItem("deviceinfo");
};

winston.add(
  new Loggly({
    token: config.LOGGLY_TOKEN,
    subdomain: config.LOGGLY_SUB_DOMAIN,
    tags: config.LOGGLY_TAGS,
    json: true,
  })
);

export const info = (msg) => {
  winston.info({ msg, deviceinfo: getDeviceInfo() }, { tags: ClientUtil.getClientKey() });
};

export const error = (msg) => {
  winston.error({ msg, deviceinfo: getDeviceInfo() }, { tags: ClientUtil.getClientKey() });
};

export const warn = (msg) => {
  winston.warn({ msg, deviceinfo: getDeviceInfo() }, { tags: ClientUtil.getClientKey() });
};

export const debug = (msg) => {
  winston.debug({ msg, deviceinfo: getDeviceInfo() }, { tags: ClientUtil.getClientKey() });
};
